export default "__VITE_ASSET__q5WqGPUJ__"